import type { AnalysisSpecItem } from '@/model/analysisSpec/dto.generated';
import { useTrans } from '@/shared/hooks/useTranslation';
import {
  TOAST_DURATION_MS,
  latestSpecsByName,
  specKey,
} from '@/viewmodel/features/observability/mappers/runNotificationData';
import { notify } from '@/viewmodel/shared/notify';
import { useEffect, useRef } from 'react';

export function useSpecRunNotifications(specs: (AnalysisSpecItem | null)[] | undefined): void {
  const { t } = useTrans();
  const activeSpecsRef = useRef<Set<string>>(new Set());
  const notifiedSpecsRef = useRef<Set<string>>(new Set());

  useEffect(() => {
    if (specs === undefined) return;

    for (const spec of latestSpecsByName(specs)) {
      const name = spec.analysis_spec_name;
      const key = specKey(name, spec.version);
      const status = spec.status.toUpperCase();

      if (status !== 'SUCCESS' && status !== 'FAILURE') {
        activeSpecsRef.current.add(key);
        continue;
      }

      if (!activeSpecsRef.current.has(key)) continue;
      if (notifiedSpecsRef.current.has(key)) continue;

      notifiedSpecsRef.current.add(key);
      if (status === 'SUCCESS') {
        notify(t('notifications.gold.success', { name }), 'success', {
          duration: TOAST_DURATION_MS,
        });
      } else {
        notify(t('notifications.failure.toastGeneric', { name }), 'danger', {
          duration: TOAST_DURATION_MS,
        });
      }
    }
  }, [specs, t]);
}
